import type { UserDoc } from '../../../types/domain';
import { defaultAppRoute } from '../../../shell/nav-items';

export function getPostAuthPath(userDoc: UserDoc | null): string {
  if (!userDoc?.customerCompleted && !userDoc?.isGlobalAdmin) return '/complete-user';
  return defaultAppRoute;
}
